/**
 * Helpers Functions
 */
import moment from 'moment';

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return (
      'rgba(' +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
      ',' +
      alpha +
      ')'
    );
  }
  throw new Error('Bad Hex');
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

/**
 * Get Date
 */
export function getTheDate(timestamp, format) {
  let time = timestamp * 1000;
  let formatDate = format ? format : 'MM-DD-YYYY';
  return moment(time).format(formatDate);
}

/**
 * Convert Date To Timestamp
 */
export function convertDateToTimeStamp(date, format) {
  let formatDate = format ? format : 'YYYY-MM-DD';
  return moment(date, formatDate).unix();
}

/**
 * Convert Date To Timestamp
 */
export function isoToSqlDate(isoDate) {
  if (!isoDate) return '0000-00-00';

  return isoDate.split('T')[0];
}

export function formatDateTime(_isoDateTime = '', model) {
  let dateTimeContent = [];

  const isoDateTime = _isoDateTime.toString();

  if (isoDateTime.toString().includes('T')) {
    dateTimeContent = isoDateTime.split('T');
  } else {
    dateTimeContent = isoDateTime.split(' ');
  }

  const date = dateTimeContent[0];
  const time = dateTimeContent[1];

  let year = '',
    month = '',
    day = '',
    hours = '',
    minutes = '',
    seconds = '';

  if (date) {
    const dateContent = date.split('-');

    year = dateContent[0];
    month = dateContent[1];
    day = dateContent[2];
  }

  if (time) {
    const timeContent = time.split(':');

    hours = timeContent[0];
    minutes = timeContent[1];
    seconds = timeContent[2];
  }

  return model
    .replace('Y', year)
    .replace('M', month)
    .replace('D', day)
    .replace('h', hours)
    .replace('m', minutes)
    .replace('s', seconds);
}

//export function dateToSqk

export function formatTime(seconds, minutesDesc = ':', secondesDesc = ':') {
  let hours = 0;
  let minutes = 0;

  if (seconds > 59) {
    minutes = parseInt(seconds / 60);
    seconds = seconds % 60;
  } else {
    return `${seconds}${secondesDesc}`;
  }

  if (minutes > 59) {
    hours = parseInt(minutes / 60);
    minutes = minutes % 60;

    return `${hours}h${minutes}${minutesDesc}${
      secondesDesc !== '' ? seconds : ''
    }${secondesDesc}`;
  } else {
    return `${minutes}${minutesDesc}${seconds}${secondesDesc}`;
  }
}

/**
 * Function to return current app layout
 */
export function getAppLayout(url) {
  let location = url.pathname;
  let path = location.split('/');
  return path[1];
}

/**
 * Função pegar params
 */
export function getQueryParams(query = '') {
  if (query === '') return {};

  let params = {};

  query
    .replaceAll('%20', ' ')
    .replace('?', '')
    .split('&')
    .forEach((p) => (params[p.split('=')[0]] = p.split('=')[1]));

  return params;
}

export function validaCNPJ(cnpj) {
  console.log('valida cnpj', cnpj);
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj == '') return false;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == '00000000000000' ||
    cnpj == '11111111111111' ||
    cnpj == '22222222222222' ||
    cnpj == '33333333333333' ||
    cnpj == '44444444444444' ||
    cnpj == '55555555555555' ||
    cnpj == '66666666666666' ||
    cnpj == '77777777777777' ||
    cnpj == '88888888888888' ||
    cnpj == '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;

    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  if (resultado != digitos.charAt(1)) return false;

  return true;
}
